export const tr = {
    'unhandled-error': 'İstek gönderilirken hata oluştu'
};
